<template>
  <div
    class="top-bar"
    v-if="generalMsg.text != ''"
    :style="
      `background-color:` + generalMsg.background_color + `; color:` + generalMsg.text_color + `;`
    "
  >
    <img
      src="@/esf_venlo_base/assets/svg/annoucement.svg"
      class="annoucement-icon"
      alt="annoucement-icon"
    />
    <span class="top-bar-text" v-html="generalMsg.text"></span>
  </div>

  <header id="header"  v-if="isClient">
    <BRow no-gutters class="navbar" :class="headerClass">
      <BCol cols="4" md="3" class="px-0">
        <b-link to="/">
          <img
            src="@/esf_venlo_base/assets/images/dark-logo.png"
            class="logo"
            width="150"
            alt="Logo"
          />
        </b-link>
      </BCol>
      <BCol lg="5" class="d-none d-lg-block px-0">
        <HeaderSearch v-if="isLoggedIn" />
      </BCol>
      <BCol cols="8" lg="3" class="px-0">
        <HeaderTopIcons showType="M" />
      </BCol>
    </BRow>
    <div
      class="mobile-header-search"
      :class="!isDesktop && isLoggedIn ? 'd-flex align-items-center' : 'd-none'"
    >
      <!-- <Navbar /> -->
      <HeaderSearch class="d-block d-lg-none" v-if="!isDesktop" />
    </div>
  </header>
</template>
<script setup>
import { ref, onMounted, computed } from "vue";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import HeaderSearch from "@/esf_venlo_base/core/components/header/HeaderSearch";
import HeaderTopIcons from "@/esf_venlo_base/core/components/header/HeaderTopIcons";
import { useDeviceDetection } from "@/esf_venlo_base/store/composable/useDeviceDetection";
import { useStore } from "vuex";
// import { useRoute } from "vue-router";

const { isDesktop } = useDeviceDetection();
const store = useStore();
const generalMsg = computed(() => store.state.messages.generalMsg);
const isClient = ref(false);
const isLoggedIn = computed(() => store.getters["user/getIsLoggedIn"]);
// const route = useRoute();
// const cleanedPath = route.fullPath.replace(/(\/en|\/de)/, "");
const headerClass = computed(() => {
  return /*cleanedPath == "/" &&*/ isDesktop ? "container" : "";
});

onMounted(() => {
  isClient.value = true;
});
</script>
